import MoreFilters from './MoreFilters';

export default MoreFilters;